export default "__VITE_ASSET__Zg63X1uE__"